// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f448eec0876c9d140d13","691":"d1a036cacbfc15321f41"}[chunkId] + ".js";
};